import React, { HTMLAttributes } from 'react';
import { useStyles } from './LocationSelector.styles';
import { Autocomplete, AutocompleteRenderInputParams, FilterOptionsState, TextField, Typography } from '@mui/material';
import { Field } from 'formik';
import { LocationOptionData } from '../../interfaces/LocationOptionData';

interface Props {
  name: string;
  label?: string;
  placeholder?: string;
  options: LocationOptionData[];
  value: LocationOptionData[];
  onChange: (fieldName: string, newValue: LocationOptionData[]) => void;
}

export const LocationSelector: React.FC<Props> = ({
  name,
  label = 'Legal locations',
  placeholder,
  options,
  value,
  onChange,
}) => {
  const styles = useStyles();

  return (
    <Field
      name={name}
      component={Autocomplete}
      className={styles.selectorInput}
      multiple
      filterOptions={(x: LocationOptionData[], state: FilterOptionsState<LocationOptionData>) =>
        x.filter((option) => option.name.toLowerCase().includes(state.inputValue.toLowerCase()))
      }
      getOptionLabel={(option: LocationOptionData) => option.name}
      noOptionsText="No such location"
      options={options}
      value={value}
      onChange={(_: React.SyntheticEvent, newValue: LocationOptionData[]) => onChange(name, newValue)}
      renderInput={(params: AutocompleteRenderInputParams) => (
        <TextField
          {...params}
          fullWidth
          label={label}
          placeholder={(value as LocationOptionData[]).length === 0 ? placeholder || 'All locations' : undefined}
        />
      )}
      renderOption={(props: HTMLAttributes<HTMLLIElement>, option: LocationOptionData) => {
        return (
          <li {...props} className={`${props.className} ${styles.option}`}>
            {option.isLocationArea ? (
              option.name
            ) : (
              <>
                <Typography variant="body2" fontSize="22px" className={styles.dot}>
                  ∙
                </Typography>
                {option.name}
              </>
            )}
          </li>
        );
      }}
    />
  );
};
